export const LIST_PAGE_CHECKOUT = "LIST_PAGE_CHECKOUT";
export const CREATE_PAGE_CHECKOUT = "CREATE_PAGE_CHECKOUT";
export const UPDATE_PAGE_CHECKOUT = "UPDATE_PAGE_CHECKOUT";
export const SHOW_PAGE_CHECKOUT = "SHOW_PAGE_CHECKOUT";
export const RELOAD_PAGE_CHECKOUT = "RELOAD_PAGE_CHECKOUT";
export const DELETE_PAGE_CHECKOUT = "DELETE_PAGE_CHECKOUT";
export const DELETES_PAGE_CHECKOUT = "DELETES_PAGE_CHECKOUT";
export const PAGE_COUSE_SHOW = "PAGE_COUSE_SHOW";
